import React, { Component } from 'react'
import MosaicValleDeTenza from './valleDeTenza/Mosaic'
import MosaicMochileros from './mochileros/Mosaic'
import MosaicPaez from './paez/Mosaic'
import MosaicUmbita from './umbita/Mosaic'
import { Row, Col } from 'antd'

export default class Home extends Component {
  render () {
    return (
      <Row type='flex' justify='left' style={{ padding: '10px' }} gutter={8}>
        <Col xs={24} lg={12} style={{ marginBottom: '10px' }}>
          <MosaicMochileros />
        </Col>
        <Col xs={24} lg={12} style={{ marginBottom: '10px' }}>
          <MosaicValleDeTenza />
        </Col>
        <Col xs={24} lg={12} style={{ marginBottom: '10px' }}>
          <MosaicPaez />
        </Col>
        <Col xs={24} lg={12} style={{ marginBottom: '10px' }}>
          <MosaicUmbita />
        </Col>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/boards/Home.js